import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const WorkCenterCapacity = () => import('./pages');

const moduleRoute = {
  path: 'manufacturing/work-center-capacity',
  name: 'WorkCenterCapacity',
  component: WorkCenterCapacity,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.JOB_ORDERS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
    breadcrumb: { leafKey: 'capacity-loading' },
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
